export default __webpack_public_path__ + "static/media/engineer9.988682a7.png";